import React, { useState, useRef } from 'react';
import { DataCollapsed } from '../../components/elements/DataCollapsed';
import {
    ButtonGroup, FormGroup, Label, Input, Badge, Tooltip,
    Dropdown, DropdownMenu, DropdownItem, DropdownToggle,
    Button,Col

} from 'reactstrap';
import { TableItemSubLista } from './TableItemSubLista';
import { TooltpTable } from './TooltpTable';
import './StyleTable.css';




export const TableItem = (props) => {
    const { radioButton, checkBoxInput, inputButton, indices, items, methodsActions, handleUpdate,
        handleDelete, notMaped, elementList, numeracion, otherMethodsActions, methodsAbsolutes,
        dataCollapsed, objCollapsed, longitud, size, navigateUpdate, iconModal, methodModal, methodM,
        methodsModal,
        //dropdwo
        methodActiveDropdown, methodDropdown,
        //method Dashboard
        dataBadge, dataBadgeType,
        //status dashboard
        statusOrder, paid_wo,
        methodsInvoice,
        handleUpdate2,
        handleDelete2,
        
    } = props;

    const array_values = Object.values(items);
    const array_keys = Object.keys(items);

    //*VARIABLES GLOBALES
    let enable_tracking_toma = localStorage.getItem('enable_tracking_toma');




    let visibleTabla = false;
    let typeExamAux = "";

    // console.groupCollapsed("DATA DE OBJETOS")
    array_keys.forEach((obj, index) => {
     
        if (obj === "visibleTable") {
            let valor = array_values[index];

            visibleTabla = valor;
        } else {
            visibleTabla = true;
        }

        if (obj === "typeExam") {
            let valor = array_values[index];
            typeExamAux = valor;
        }
    });

    if (notMaped !== null || elementList !== null) {
        array_keys.forEach((obj, key) => {
          

            if (notMaped !== null) {
                notMaped.forEach((elem, index) => {
                    if (elem === obj) {
                        array_values[key] = undefined;
                    }
                })
            }
        });
    }


    


    const [isOpen, setIsOpen] = useState(false);
    //TOOLTIP
    const [tooltip, setTooltip] = useState(false);
    const [tooltipRelease, setTooltipRelease] = useState(false);

    const toggleTooltip = () => setTooltip(!tooltip);
    const toggleTooltipRelease = () => setTooltipRelease(!tooltipRelease);

    const [tooltip2, setTooltip2] = useState(false);
    const [tooltipRelease2, setTooltipRelease2] = useState(false);

    const toggleTooltip2 = () => setTooltip2(!tooltip2);
    const toggleTooltipRelease2 = () => setTooltipRelease2(!tooltipRelease2);

    const [tooltip3, setTooltip3] = useState(false);
    const [tooltipRelease3, setTooltipRelease3] = useState(false);

    const toggleTooltip3 = () => setTooltip3(!tooltip3);
    const toggleTooltipRelease3 = () => setTooltipRelease3(!tooltipRelease3);


    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle4 = () => setDropdownOpen(prevState => !prevState);
    


    return (
        <>
            <tr className={paid_wo != undefined ? paid_wo == true ? `text-center border-bottom-info  ${!visibleTabla && "d-none"}` : `text-center  colorTable border-bottom-info` : `text-center border-bottom-info  ${!visibleTabla && "d-none"}`}>
                {
                    array_values.length > 0 &&
                    array_values.map((obj, key) => {
                      
                        if (obj !== undefined) {
                            if (typeof (obj) === "object") {
                                if (obj !== null) {

                                    if (obj.length > 0) {
                                        if (obj[0][0] === true) {
                                            return <td style={{ width: "200px" }} key={key}  >
                                                <ul style={{ paddingLeft: 0 }}>
                                                    {
                                                        obj.map((element, key1) => {
                                                            return <TableItemSubLista key={key1} {...{ key1, element }} />
                                                        })
                                                    }
                                                </ul>
                                            </td>
                                        } else {
                                            return (<td key={key} >
                                                {obj.map((element, index) => (

                                                    <li key={index}>{element}</li>
                                                ))}
                                            </td>);
                                        }
                                    } else {
                                        //revisar este  pendiente si afecta las tablas que vengan con un objeto
                                        return <td key={key}   >{obj}  </td>
                                    }
                                } else {
                                    return <td key={key}></td>
                                }
                            } else if (typeof (obj) === "boolean") {
                                return <td style={{ width: "65px" }} key={key} >
                                    {(obj) ? "SI" : "NO"}
                                </td>
                            } else {
                                if (key === 0) {

                                    if (indices !== false) { //labelCancell
                                        return <td style={{ width: "px" }} key={key} className={key}>
                                            {numeracion}
                                        </td>
                                    } else {
                                        return <td key={key} className={key}>
                                            {obj}
                                        </td>
                                    }
                                } else {

                                    return <td style={{ width: "px" }} key={key} className={key}>
                                        {
                                            obj === "Incompleto" ? <span className="badge badge-danger">{obj}</span> : (obj === "Completado" ? <span className="badge badge-success">{obj}</span> : obj)
                                        }
                                    </td>
                                }
                            }
                        } else {
                            return false;
                        }
                    })
                }
                {
                    radioButton !== false &&
                    <td style={{ width: "px" }}>
                        <FormGroup check>
                            <Label check>
                                <Input onClick={() => radioButton.methodRadioButton(array_values[0])} defaultChecked={array_values[0] === radioButton.radioButtonChecked ? true : false} type="radio" name="radio1" />Seleccionar
                            </Label>
                        </FormGroup>
                    </td>
                }
                {
                    checkBoxInput !== false &&
                    <td style={{ width: "px" }}>
                        <div className="checkbox checkbox-primary">
                            <Input id={"checkbox-primary-" + numeracion} type="checkbox" defaultChecked={checkBoxInput.valor} onChange={(e) => checkBoxInput.methodCheckedCheck(e, array_values[0])} />
                            <Label for={"checkbox-primary-" + numeracion}></Label>
                        </div>
                    </td>
                }
                {
                    inputButton !== false &&
                    <td style={{ width: "px" }}>
                    </td>
                }
                {
                    iconModal !== false &&
                    <td style={{ width: "px" }}>
                        <Badge
                            style={{ cursor: "pointer" }}
                            onClick={() => iconModal.method(array_values[0])}
                        >
                            <i className={iconModal.icon} >
                            </i>
                        </Badge>
                    </td>
                }
                {
                    methodsInvoice === true  &&  null
                      
                }

                {
                    methodsModal === true && null
                }

                {
                    methodActiveDropdown === true ?
                        <>
                            <td style={{ width: "px" }}>
                                <Dropdown isOpen={dropdownOpen} toggle={toggle4}>
                                    <DropdownToggle outline color='primary' size='xs' caret>Acciones</DropdownToggle>
                                    <div className="dropdown-content" color='primary'>
                                        <DropdownMenu>
                                            {
                                                methodDropdown !== null &&
                                                methodDropdown.map((obj, key) => {
                                                    if (obj.type === "Drop") {
                                                        if (array_values.indexOf(26)) {
                                                            if (array_values[26] === "Sencillo") {
                                                                if (obj.name === "navigateCreateOrUpdateAnalytes") {
                                                                    return false;
                                                                }
                                                                if (obj.name === "navigateConfigExam") {
                                                                    return false;
                                                                }
                                                                return (<DropdownItem
                                                                    key={key}
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() => obj.method(array_values[0])}
                                                                >
                                                                    <i style={{ color: obj.color }} className={obj.icon}></i>
                                                                    {
                                                                        obj.nameAction
                                                                    }
                                                                </DropdownItem>
                                                                )
                                                            }
                                                            else {
                                                                return (<DropdownItem
                                                                    key={key}
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() => obj.method(array_values[0])}
                                                                >
                                                                    <i style={{ color: obj.color }} className={obj.icon}></i> &nbsp;
                                                                    {
                                                                        obj.nameAction
                                                                    }
                                                                </DropdownItem>
                                                                )
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        return false;
                                                    }
                                                })
                                            }
                                        </DropdownMenu>
                                    </div>
                                </Dropdown>
                            </td>
                        </>
                        :
                        null
                }
                {
                   enable_tracking_toma  !== "True" && null
                }
                {
                    statusOrder === true && null     
                }
                {
                    methodsActions === true ?
                        <td style={{}}>
                            <ButtonGroup className="btn-xs" style={{ cuersor: "pointer" }}>
                                {
                                    dataCollapsed !== null &&
                                    (!items.isTemp) &&
                                    <button
                                        style={{ cursor: "pointer" }}
                                        className={`btn-icon btn ${(size === "table-sm" ? "pt-1 pb-1 pr-3 pl-3" : "pt-1 pb-1 pr-2 pl-2")} btn-sm btn-secondary`}
                                        onClick={() => setIsOpen(!isOpen)}
                                    >
                                        <i className="fa fa-eye"></i>
                                    </button>
                                }
                                {
                                    otherMethodsActions !== null &&
                                    otherMethodsActions.map((obj, key) => {
                                        
                                        if (!items.isTemp) {
                                            if (obj.type === "linkId") {
                                                return (<button
                                                    key={key}
                                                    className={`btn-icon btn ${(size === "table-sm" ? "pt-1 pb-1 pr-3 pl-3" : "pt-1 pb-1 pr-2 pl-2")} btn-sm`}
                                                    style={{ backgroundColor: obj.backgroundColor, color: obj.color }}
                                                    onClick={() => obj.method(obj.position !== undefined ? array_values[obj.position] : array_values[0])}
                                                >
                                                    <i className={obj.icon}></i>

                                                </button>)
                                            } else {
                                                return false;
                                            }
                                        } else {
                                            return false;
                                        }
                                    })
                                }
                                {
                                    methodModal !== null &&
                                    methodModal.map((obj, key) => {
                                        if (obj.type === "ModId") {
                                            return <Badge
                                                key={key}
                                                onClick={() => obj.method(array_values[0])}
                                            >
                                                <i className={obj.icon}></i>
                                            </Badge>
                                        }
                                        else {
                                            return false;
                                        }
                                    })
                                }

                                {//28
                                    methodsAbsolutes !== null &&
                                    methodsAbsolutes.map((obj, key) => {
                                        
                                        if (obj.type === "linkId") {
                                            // ? DISABLED 
                                            if (obj?.disabled === "disabledCompany" &&  !items?.microsite) {
                                                return false;
                                            }

                                            if (typeExamAux !== "") {
                                                if (typeExamAux === "Sencillo") {
                                                    if (obj.name === "navigateCreateOrUpdateAnalytes") {
                                                        return false;
                                                    }
                                                    if (obj.name === "navigateMicroAnalytes") {
                                                        return false;
                                                    }
                                                    if (obj.name === "navigateConfigExam") {
                                                        return false;
                                                    }
                                                    console.log(array_values);
                                                    

                                                    return (<button
                                                        type="button"
                                                        key={key}
                                                        className={`btn-icon btn ${(size === "table-sm" ? "pt-1 pb-1 pr-3 pl-3" : "pt-1 pb-1 pr-2 pl-2")} btn-sm`}
                                                        style={{ backgroundColor: obj.backgroundColor, color: obj.color }}
                                                        onClick={() => obj.method(array_values[0])}
                                                    >
                                                        <i
                                                            id={"tooltip-" + obj.name + array_values[0]}
                                                            className={obj.icon}>
                                                            <TooltpTable
                                                                obj={obj}
                                                                idTool={array_values[0]}
                                                            />
                                                        </i>
                                                    </button>)
                                                }
                                                else {
                                                    if (array_values[32] === "Imagenologia") {
                                                        if (obj.name === "navigateCreateOrUpdateAnalytes") {
                                                            return false;
                                                        }
                                                        if (obj.name === "navigateMicroAnalytes") {
                                                            return false;
                                                        }
                                                        if (obj.name === "navigateConfigExam") {
                                                            return false;
                                                        }
                                                    } else if (array_values[32] === "Micro") {
                                                        if (obj.name === "navigateCreateOrUpdateAnalytes") {
                                                            return false;
                                                        }
                                                        if (obj.name === "navigateConfigExam") {
                                                            return false;
                                                        }
                                                    }
                                                    return (
                                                        <button
                                                            type="button"
                                                            key={key}
                                                            className={`btn-icon btn ${(size === "table-sm" ? "pt-1 pb-1 pr-3 pl-3" : "pt-1 pb-1 pr-2 pl-2")} btn-sm`}
                                                            style={{ backgroundColor: obj.backgroundColor, color: obj.color }}
                                                            onClick={() => obj.method(array_values[0])}

                                                        >
                                                            <i
                                                                className={obj.icon}
                                                                id={"tooltip-" + obj.name + array_values[0]}
                                                            >
                                                                <TooltpTable
                                                                    obj={obj}
                                                                    idTool={array_values[0]}
                                                                />
                                                            </i>
                                                        </button>)
                                                }
                                            } else {
                                                return (
                                                    <button
                                                        type="button"
                                                        key={key}
                                                        className={`btn-icon btn ${(size === "table-sm" ? "pt-1 pb-1 pr-3 pl-3" : "pt-1 pb-1 pr-2 pl-2")} btn-sm`}
                                                        style={{ backgroundColor: obj.backgroundColor, color: obj.color }}
                                                        onClick={() => obj.method(array_values[0], items.bussines_name)}

                                                    >
                                                        <i
                                                            className={obj.icon}
                                                            // id={"tooltip-" + obj.name + array_values[0]}
                                                        >
                                                            {/* <TooltpTable
                                                                obj={obj}
                                                                idTool={array_values[0]}
                                                            /> */}
                                                        </i>
                                                    </button>)
                                            }
                                        }
                                        else if (obj.type === "QrCodeMembership") {
                                            if (array_values.indexOf(18)) {
                                                if (array_values[18] !== null) {
                                                    return (
                                                        <button
                                                            type="button"
                                                            key={key}
                                                            className={`btn-icon btn ${(size === "table-sm" ? "pt-1 pb-1 pr-3 pl-3" : "pt-1 pb-1 pr-2 pl-2")} btn-sm`}
                                                            style={{ backgroundColor: obj.backgroundColor, color: obj.color }}
                                                            onClick={() => obj.method(array_values[0])}

                                                        >
                                                            <i
                                                                className={obj.icon}
                                                                id={"tooltip-" + obj.name + "qr" + array_values[0]}
                                                            >
                                                                <TooltpTable
                                                                    obj={obj}
                                                                    idTool={"qr" + array_values[0]}
                                                                />
                                                            </i>
                                                        </button>
                                                    )
                                                }
                                            }
                                        }
                                        else {
                                            return false;
                                        }
                                    })
                                }

                                {
                                    handleUpdate && <button
                                        className={`btn-icon btn ${(size === "table-sm" ? "pt-1 pb-1 pr-3 pl-3" : "pt-1 pb-1 pr-2 pl-2")} btn-sm btn-info`}
                                        onClick={() => handleUpdate(array_values[0])}
                                    // id={`tooltipRelaese-${array_values[0]}`} 
                                    >
                                        <i
                                            id={`tooltipRelaese-${array_values[0]}`}
                                            className="fa fa-edit f-14">

                                            <Tooltip
                                                placement={"top"}
                                                isOpen={tooltipRelease}
                                                target={"tooltipRelaese-" + array_values[0]}
                                                toggle={toggleTooltipRelease}
                                            >
                                                {`Editar`}
                                            </Tooltip>
                                        </i>

                                    </button>
                                }
                                {
                                    handleUpdate2 && <button
                                        className={`btn-icon btn ${(size === "table-sm" ? "pt-1 pb-1 pr-3 pl-3" : "pt-1 pb-1 pr-2 pl-2")} btn-sm btn-info`}
                                        onClick={() => handleUpdate2(array_values[0])}
                                    // id={`tooltipRelaese-${array_values[0]}`} 
                                    >
                                        <i
                                            id={`tooltipRelaese-${array_values[0]}`}
                                            className="fa fa-edit f-14">

                                            <Tooltip
                                                placement={"top"}
                                                isOpen={tooltipRelease}
                                                target={"tooltipRelaese-" + array_values[0]}
                                                toggle={toggleTooltipRelease}
                                            >
                                                {`Editar`}
                                            </Tooltip>
                                        </i>

                                    </button>
                                }
                                {
                                    navigateUpdate && checkBoxInput
                                        ?
                                        checkBoxInput.valor ? "" : <button
                                            className={`btn-icon btn ${(size === "table-sm" ? "pt-1 pb-1 pr-3 pl-3" : "pt-1 pb-1 pr-2 pl-2")} btn-sm btn-info`}
                                            onClick={() => navigateUpdate(array_values[0])}
                                        >
                                            <i className="fa fa-edit"></i>
                                        </button>
                                        : ""
                                }
                                {
                                    handleDelete && <button
                                        className={`btn-icon btn ${(size === "table-sm" ? "pt-1 pb-1 pr-3 pl-3" : "pt-1 pb-1 pr-2 pl-2")} btn-sm btn-danger`}
                                        //onClick={() => handleDelete(array_values[0])}
                                        onClick={() => handleDelete(array_values[0], items.bussines_name)}

                                    // id={`tooltipRelaese2-${array_values[0]}`} 
                                    >
                                        <i
                                            id={`tooltipRelaese2-${array_values[0]}`}
                                            className="fa fa-trash f-14">

                                            <Tooltip
                                                placement={"top"}
                                                isOpen={tooltipRelease2}
                                                target={"tooltipRelaese2-" + array_values[0]}
                                                toggle={toggleTooltipRelease2}
                                            >

                                                {`Eliminar`}
                                            </Tooltip>


                                        </i>

                                    </button>
                                }
                                 {
                                    handleDelete2 && <button
                                        className={`btn-icon btn ${(size === "table-sm" ? "pt-1 pb-1 pr-3 pl-3" : "pt-1 pb-1 pr-2 pl-2")} btn-sm btn-danger`}
                                        onClick={() => handleDelete2(array_values[0])}
                                    // id={`tooltipRelaese2-${array_values[0]}`} 
                                    >
                                        <i
                                            id={`tooltipRelaese2-${array_values[0]}`}
                                            className="fa fa-trash f-14">

                                            <Tooltip
                                                placement={"top"}
                                                isOpen={tooltipRelease2}
                                                target={"tooltipRelaese2-" + array_values[0]}
                                                toggle={toggleTooltipRelease2}
                                            >

                                                {`Eliminar`}
                                            </Tooltip>


                                        </i>

                                    </button>
                                }

                            </ButtonGroup>
                        </td>
                        :
                        null
                }
                {//*CONFIGURATION GLOBAL
                    dataBadge === true ?
                        <>
                            <td>
                                {
                                    items.id_estatus_order != 20 ?
                                        dataBadgeType !== null &&
                                        dataBadgeType.map((obj, key) => {
                                            //!CONFIGURATION BADGE
                                            if (obj.type === "idAction") {
                                                return <Badge key={key} style={{ cursor: "pointer" }} onClick={() => obj.method(array_values[0], items.nim2,items.phone_patient,items.UUID)} color={obj.color}  title={obj.tooltip} >
                                                    {/* <i id={"tooltip-" + obj.name + array_values[0]} className={obj.icon} color={obj.colortxt}>
                                                        <TooltpTable
                                                            obj={obj}
                                                            idTool={array_values[0]}
                                                        />
                                                    </i> */}
                                                      <i className={obj.icon} style={{ color: obj.colortxt }}></i>

                                                </Badge>
                                            }
                                            else {
                                                return false;
                                            }
                                        })
                                        : null
                                }
                            </td>
                        </>
                        :
                        null
                }

            </tr>
            {
                dataCollapsed !== null &&
                <DataCollapsed longitud={longitud} objCollapsed={objCollapsed} isOpen={isOpen} />
            }
        </>
    )
}
